import buttonBase from './_buttonBase';
import loadExternalScript from '@Shared/Common/Scripts/Util/_loadExternalScript.js';
export default {
  extends: buttonBase,
  methods: {
    performAction: function performAction() {
      // show the third party script modal
      if (this.$_checkForprivacyOptOut(this.button) == true) {
        return;
      } // show the whisk modal


      if (this.button.scriptUrl && this.button.scriptId) {
        if (this.button.onLoadFunction) {
          var callbackFn = new Function(this.button.onLoadFunction);
          loadExternalScript(this.button.scriptUrl, this.button.scriptId, callbackFn);
        } else {
          loadExternalScript(this.button.scriptUrl, this.button.scriptId);
        }
      }

      return true;
    }
  }
};